module.exports = __webpack_public_path__ + "img/doctor.ffbb3263.png";